import { render, staticRenderFns } from "./shippingProductSelect.vue?vue&type=template&id=2dd39b22"
import script from "./shippingProductSelect.vue?vue&type=script&lang=js"
export * from "./shippingProductSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports